export const menuItems = [
  {
    key: "understand",
    label: "Understand",
    type: "section",
    icon: "bi bi-grid-1x2-fill",
    children: [
      {
        key: "socio-impact-analysis",
        label: "Socio Impact Analysis",
        icon: "bi bi-pie-chart-fill"
      },
      {
        key: "socio-impact-regional-convergence",
        label: "Socio Impact Regional Convergence",
        icon: "bi bi-globe2"
      },
      {
        key: "utilities",
        label: "Causation Engine",
        icon: "bi bi-arrow-repeat"
      },
      {
        key: "operations-overview",
        label: "Interview Insights",
        icon: "bi bi-chat-left-text-fill"
      },
      {
        key: "security",
        label: "Geographic Analysis",
        icon: "bi bi-geo-alt-fill"
      }
    ]
  },

  {
    key: "measure",
    label: "Measure",
    type: "section",
    icon: "bi bi-bar-chart-line-fill",
    children: [
      {
        key: "connectivity",
        label: "Production Impact",
        icon: "bi bi-building"
      },
      {
        key: "energy",
        label: "Investment Tracker",
        icon: "bi bi-cash-stack"
      }
    ]
  },

  {
    key: "act",
    label: "Act",
    type: "section",
    icon: "bi bi-graph-up",
    children: [
      {
        key: "insights-analytics",
        label: "Predictive Analytics",
        icon: "bi bi-bullseye"
      }
    ]
  }
];

export function formatProperties(properties) {
  return (properties || []).map(item => ({
    id: item.id,
    label: item.title,
    icon: item.icon || "bi bi-building"
  }));
}
